/*
  ====================================================
  FILE: product-embed-blogs.js

  DROP THIS FILE INTO: Shopify Admin → Themes → Edit Code → Assets

  THEN add this line inside theme.liquid just before </body>:
    {% if request.page_type == 'article' %}
      {{ 'product-embed-blogs.js' | asset_url | script_tag }}
    {% endif %}

  ====================================================
  MONTHLY EDIT: Change the two product handles below.
  Find a product's handle in its storefront URL:
  e.g. yourstore.com/products/MY-HANDLE-IS-HERE

  WAITLIST (Sept 2026, restock gap): while waitlist is true, both
  cards say "Restocking soon" and link to the waitlist page.
  When the new harvest is in stock, change waitlist to false.
  ====================================================
*/

const BPE_CONFIG = {
  product1: 'lina-extra-virgin-olive-oil-500ml-bottle',   // ← EDIT THIS
  product2: 'turi-extra-virgin-olive-oil-500ml-bottle',   // ← EDIT THIS
  buttonText: 'Shop Now',                                 // ← Optional: change button label

  waitlist: true,                                         // ← true = waitlist cards, false = Shop Now
  waitlistButton: 'Join the waitlist',
  waitlistLink: '/pages/waitlist',
  badge: "Named one of the world's best olive oils",      // ← black box on the photo
  status: 'Restocking soon',                              // ← shown instead of the price
  blurb: 'Award-winning, made in Calabria and regeneratively farmed. Get first access before it opens to everyone.',
};

/* ====================================================
   DO NOT EDIT BELOW THIS LINE
   ==================================================== */

async function fetchProduct(handle) {
  try {
    const res = await fetch(`/products/${handle}.js`);
    if (!res.ok) return null;
    return await res.json();
  } catch (e) {
    console.warn(`[Blog Product Embed] Could not load product: ${handle}`);
    return null;
  }
}

function formatMoney(cents) {
  return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

function buildCard(product) {
  if (!product) return '<div class="bpe-card bpe-card--empty"></div>';

  const c = BPE_CONFIG;
  const link = c.waitlist ? c.waitlistLink : `/products/${product.handle}`;

  const image = product.featured_image
    ? `<a href="${link}" class="bpe-image-link">
         <img class="bpe-image" src="${product.featured_image}" alt="${product.title}" loading="lazy">
       </a>`
    : '';

  const badge = c.waitlist
    ? `<span style="position:absolute;top:24px;left:16px;background:#1a1a1a;color:#f7f3e8;font-size:13px;font-weight:600;letter-spacing:.09em;text-transform:uppercase;padding:8px 12px">${c.badge}</span>`
    : '';

  const price = c.waitlist
    ? `<span class="bpe-price" style="font-weight:600;letter-spacing:.08em;text-transform:uppercase">${c.status}</span>`
    : `<span class="bpe-price">${formatMoney(product.price_min)}</span>` +
      (product.compare_at_price_min > product.price_min
        ? `<span class="bpe-price-compare">${formatMoney(product.compare_at_price_min)}</span>`
        : '');

  const blurb = c.waitlist ? `<p style="margin:6px 0 14px;font-size:14px;line-height:1.45;color:#444">${c.blurb}</p>` : '';

  return `
    <div class="bpe-card" style="position:relative">
      ${image}
      ${badge}
      <div class="bpe-card-body">
        <h3 class="bpe-title">
          <a href="${link}">${product.title}</a>
        </h3>
        <div class="bpe-price-row">
          ${price}
        </div>
        ${blurb}
        <a href="${link}" class="bpe-button">
          ${c.waitlist ? c.waitlistButton : c.buttonText}
        </a>
      </div>
    </div>
  `;
}

async function initBlogProductEmbed() {
  const wrappers = document.querySelectorAll('.bpe-wrapper');
  if (!wrappers.length) return;

  const [product1, product2] = await Promise.all([
    fetchProduct(BPE_CONFIG.product1),
    fetchProduct(BPE_CONFIG.product2),
  ]);

  const html = `
    <div class="bpe-container">
      <div class="bpe-grid">
        ${buildCard(product1)}
        ${buildCard(product2)}
      </div>
    </div>
  `;

  wrappers.forEach(wrapper => {
    wrapper.innerHTML = html;
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initBlogProductEmbed);
} else {
  initBlogProductEmbed();
}